module.exports = __webpack_public_path__ + "img/material_desc.d0956e50.png";